import { Grid2, Grid2Props } from "@mui/material";
import { FC, ReactNode } from "react";

interface ContainerProps extends Grid2Props {
    children?: ReactNode; // Allow children elements
    blur?: boolean;
}

const Container: FC<ContainerProps> = ({ children, blur, sx, ...props }) => {
    return (
        <Grid2
            size={'grow'}
            borderRadius={4}
            overflow={'auto'}
            sx={{
                // backdropFilter: blur ? "blur(8px)" : undefined,
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                ...(sx || {})
            }}
            {...props}
        >
            {children}
        </Grid2>
    );
};

export default Container;
